import React, { useState } from 'react';
import { Settings, Users, FileText, Building2, AlertTriangle, HardDrive, Link2, Globe, Activity, Database, BookOpen } from 'lucide-react';
import UserManagementTab from './admin/UserManagementTab';
import AziendaSdiTab from './admin/AziendaSdiTab';
import FicSdiTab from './admin/FicSdiTab';
import ApiDocsTab from './admin/ApiDocsTab';
import ResetWorkspaceTab from './admin/ResetWorkspaceTab';
import BackupRestoreTab from './admin/BackupRestoreTab';
import LandingCMSTab from './admin/LandingCMSTab';
import HealthTab from './admin/HealthTab';
import DatasetImportTab from './admin/DatasetImportTab';
import PrezzarioSettingsTab from './admin/PrezzarioSettingsTab';

function TabBtn({ id, label, icon: Icon, active, onClick }) {
  return (
    <button
      onClick={onClick}
      data-testid={`admin-tab-${id}`}
      className={`px-4 py-2.5 text-sm font-semibold border-b-2 transition-all flex items-center gap-2 whitespace-nowrap
        ${active ? 'border-primary text-primary' : 'border-transparent text-slate-500 hover:text-slate-700'}`}
    >
      <Icon size={16} />{label}
    </button>
  );
}

const TABS = {
  dipendenti: UserManagementTab,
  azienda: AziendaSdiTab,
  fic: FicSdiTab,
  sito: LandingCMSTab,
  prezzario: PrezzarioSettingsTab,
  dataset: DatasetImportTab,
  health: HealthTab,
  api: ApiDocsTab,
  backup: BackupRestoreTab,
  reset: ResetWorkspaceTab,
};

export default function AdminPage() {
  const [tab, setTab] = useState('dipendenti');
  const ActiveTab = TABS[tab] || UserManagementTab;

  return (
    <div className="animate-fade-in" data-testid="admin-page">
      <div className="mb-6">
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight flex items-center gap-3">
          <Settings size={28} className="text-primary" /> Amministrazione
        </h1>
        <p className="text-slate-500 mt-1">Dipendenti, dati azienda e configurazione fatturazione elettronica</p>
      </div>

      <div className="flex gap-1 border-b border-slate-200 mb-5 overflow-x-auto" data-testid="admin-tabs">
        <TabBtn id="dipendenti" label="Dipendenti" icon={Users} active={tab === 'dipendenti'} onClick={() => setTab('dipendenti')} />
        <TabBtn id="azienda" label="Dati Azienda SDI" icon={Building2} active={tab === 'azienda'} onClick={() => setTab('azienda')} />
        <TabBtn id="fic" label="FattureInCloud (SDI)" icon={Link2} active={tab === 'fic'} onClick={() => setTab('fic')} />
        <TabBtn id="sito" label="Sito Pubblico" icon={Globe} active={tab === 'sito'} onClick={() => setTab('sito')} />
        <TabBtn id="prezzario" label="Prezzario" icon={BookOpen} active={tab === 'prezzario'} onClick={() => setTab('prezzario')} />
        <TabBtn id="dataset" label="Dataset Import (AI)" icon={Database} active={tab === 'dataset'} onClick={() => setTab('dataset')} />
        <TabBtn id="health" label="Diagnostica" icon={Activity} active={tab === 'health'} onClick={() => setTab('health')} />
        <TabBtn id="api" label="API & Integrazioni" icon={FileText} active={tab === 'api'} onClick={() => setTab('api')} />
        <TabBtn id="backup" label="Backup & Restore" icon={HardDrive} active={tab === 'backup'} onClick={() => setTab('backup')} />
        <TabBtn id="reset" label="Reset Workspace" icon={AlertTriangle} active={tab === 'reset'} onClick={() => setTab('reset')} />
      </div>

      <ActiveTab />
    </div>
  );
}
